import React from 'react'
import { App as AntdApp, ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { RouterProvider } from 'react-router'
import { routers } from '@/router/routerConfig'
import { payModalElement } from '@/business-component/pay-modal/PayModal'
import { QueryClientProvider } from '@tanstack/react-query'
import { getBaseQueryClient } from '@/common/client/getBaseQueryClient'
import { Down4KImage } from '@/business-component/down-4k-image/Down4KImage'
import { TaskFloatingBall } from '@/component/floating-ball/TaskFloatingBall'
import {
	StyleProvider,
	legacyLogicalPropertiesTransformer
} from '@ant-design/cssinjs'

function App() {
	return (
		<StyleProvider
			hashPriority="high"
			transformers={[legacyLogicalPropertiesTransformer]}
		>
			<ConfigProvider
				locale={zhCN}
				theme={{
					token: { colorPrimary: '#32649F' },
					cssVar: { prefix: 'dx-' }
				}}
			>
				<AntdApp>
					<QueryClientProvider client={getBaseQueryClient()}>
						<div>
							<RouterProvider
								router={routers}
								future={{ v7_startTransition: true }}
							></RouterProvider>
							{payModalElement}
							<Down4KImage />
							<TaskFloatingBall />
						</div>
					</QueryClientProvider>
				</AntdApp>
			</ConfigProvider>
		</StyleProvider>
	)
}

export default App
